import { Routes, Route , useLocation  } from "react-router-dom";
// import Devices from "../pages/Devices"
import Dashboard from "../pages/Dashboard";
import ChangeLogs from "../pages/ChangeLogs";
import DeviceData from "../pages/DeviceData";
import ManageRoles from "../pages/ManageRoles";
import ManageUsers from "../pages/ManageUsers";
import RemoteDevice from "../pages/RemoteDevice";
import PageNotFound from "../pages/PageNotFound";
import EventsToolTip from "../pages/EventsToolTip";
import ManageFirmware from "../pages/ManageFirmware";
import EventToolTipEdit from "../pages/EventToolTipEdit";
// import DownloadEventLogs from "../pages/DownloadEventLogs";
import ManageEventLogs from "../pages/ManageEventLogs";
import ManageConfigFiles from "../pages/ManageConfigFiles";
// import DownloadFreezeFrame from "../pages/DownloadFreezeFrame";
// import ManageOrganization from "../pages/ManageOrganization";
// import ManageMembers from "../pages/ManageMembers";
import ManageRoleBaseAccess from "../pages/ManageRoleBaseAccess";
import ManageAppUsers from "../pages/ManageAppUsers";
import ManageDefaultFiles from "../pages/ManageDefaultFiles";
import CreateRoleElevationRequest from "../pages/CreateRoleElevationRequest";
import ManageRolesElevationRequest from "../pages/ManageRolesElevationRequest";
import CreatePermissionsElevationRequest from "../pages/CreatePermissionsElevationRequest";
import ManagePermissionElevationRequest from "../pages/ManagePermissionElevationRequest";
import { LoginCallback } from "@okta/okta-react";
import { RequiredAuth } from "./SecureRoute";
import PermissionRoutes from "./PermissionRoutes";
import AccessDenied from "../pages/AccessDenied";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { getUserPermissionRolesData } from "../api/userpermissionsapi";
import { useOktaAuth } from '@okta/okta-react';
import ManageControllerRoleMapping from "../pages/ManageControllerRoleMapping";
import ManageHomePageInterpretationFiles from "../pages/ManageHomePageInterpretationFiles";
import ManageUnitsAndEnums from "../pages/ManageUnitsAndEnums";
import EditUnitsAndEnums from "../pages/EditUnitsAndEnums";
import ManageEnum from "../pages/ManageEnum";
import EditEnums from "../pages/EditEnums";
import ManageEnumGroup from "../pages/ManageEnumGroup";
import EditEnumsGroup from "../pages/EditEnumsGroup";
import ManageAccessCodeList from "../pages/ManageAccessCodeList";
import CreateAccessCode from "../pages/CreateAccessCode";

function MainRoutes() {

  const {  authState } = useOktaAuth();
  const location = useLocation();
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (!authState || !authState?.isAuthenticated) {
  //     return;
  //   }
  //   if(location.pathname !== '/web/access-denied'){
  //     dispatch(getUserPermissionRolesData());
  //   }
  // },[location.pathname, oktaAuth, authState]);

  const calledRef = useRef(false);

  useEffect(() => {
    if (!authState?.isAuthenticated) return;
    if (calledRef.current) return;

    calledRef.current = true;
    dispatch(getUserPermissionRolesData());
  }, [location.pathname,authState?.isAuthenticated]);
  
  return (
    <Routes>
      <Route path='login/callback' element={<LoginCallback />} />
      <Route element={<RequiredAuth />}>


        <Route element={<PermissionRoutes permission="manageDashboard"/>} >
          <Route index element={<Dashboard />}   />
          <Route path="/web/dashboard" element={<Dashboard />}/>
        </Route>

        <Route element={<PermissionRoutes permission="manageUsers"/>} >
          <Route path="/web/roles" element={<ManageRoles />}  />
          <Route path="/web/users" element={<ManageUsers />} />
          <Route path="/web/app/users" element={<ManageAppUsers />} />
          <Route path="/web/permissions" element={<ManageRoleBaseAccess />} />
          <Route path="/web/controller-permissions" element={<ManageControllerRoleMapping />} />
        </Route>

        <Route element={<PermissionRoutes permission="manageFirmware" />} >
          <Route path="/web/firmware" element={<ManageFirmware />} />
        </Route>

        <Route element={<PermissionRoutes permission="manageConfigFiles" />} >
          <Route path="/web/config-files" element={<ManageConfigFiles />} />
        </Route>
       
        <Route element={<PermissionRoutes permission="manageDefaultFiles" />} >
          <Route path="/web/default-files" element={<ManageDefaultFiles />} />
        </Route>
        
        <Route element={<PermissionRoutes permission="ManageEventLogs" />} >
          <Route path="/web/event-logs" element={<ManageEventLogs />} />
          {/* <Route path="/web/event-logs/:serialNumber/:searchBy" element={<DownloadEventLogs />} /> */}
        </Route>
       
        <Route element={<PermissionRoutes permission="manageChangeLogs" />} >
          <Route path="/web/change-logs" element={<ChangeLogs />} />
        </Route>
        
        <Route element={<PermissionRoutes permission="manageEventTooltips" />} >
          <Route path="/web/tooltips" element={<EventsToolTip />} />
          <Route path="/web/tooltips/edit/:id" element={<EventToolTipEdit />} />
        </Route>
        
        <Route element={<PermissionRoutes permission="manageRemoteSocket" />} >
          <Route path="/web/connection-requests" element={<RemoteDevice />} />
          <Route path="/web/remote-connect" element={<DeviceData />} />
        </Route>
      
        <Route element={<PermissionRoutes permission="requestEleveationRequest" />} >
          <Route path="/web/role/request" element={<CreateRoleElevationRequest />} />
          <Route path="/web/permission/request" element={<CreatePermissionsElevationRequest />} />
        </Route>
      
        <Route element={<PermissionRoutes permission="manageRequestEleveationRequest" />} >
          <Route path="/web/role/request-list" element={<ManageRolesElevationRequest />} />
          <Route path="/web/permission/request-list" element={<ManagePermissionElevationRequest />} />
        </Route>

        <Route element={<PermissionRoutes permission="manageHomePageInterpretationFile" />} >
          <Route path="/web/interpretation-files" element={<ManageHomePageInterpretationFiles />}  />
        </Route>

        <Route element={<PermissionRoutes permission="manageUnitsAndEnums" />} >
          <Route path="/web/units" element={<ManageUnitsAndEnums />}  />
          <Route path="/web/units/edit/:id" element={<EditUnitsAndEnums />} />
          <Route path="/web/enums" element={<ManageEnum />} />
          <Route path="/web/enums/edit/:id" element={<EditEnums />} />
          <Route path="/web/enum-groups" element={<ManageEnumGroup />} />
          <Route path="/web/enum-groups/edit/:id" element={<EditEnumsGroup />} />
        </Route>

        <Route element={<PermissionRoutes permission="managePasswords" />} >
          <Route path="/web/passwords" element={<ManageAccessCodeList />} />
          <Route path="/web/create-password" element={<CreateAccessCode />} />
        </Route>

        <Route path="/web/access-denied" element={<AccessDenied />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
}

export default MainRoutes;
